import { gql } from '@apollo/client';

export const GET_ALL_USERS = gql`
  query GET_ALL_USERS {
    getAllUsers {
      id
      email
      createdAt
      userType
      isBlocked

      avatar {
        fileUrl
      }

      skills {
        id
        name
      }

      professions {
        id
        name
      }

      profile {
        id
        name
        bio
        website
        collaborationStatus
        availableAt
      }
    }
  }
`;
